"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorage = void 0;
exports.LocalStorage = {
    EXPIRATION_TIME: 'expirationTime',
    EXPIRATION_IN_MINUTES: 'expirationInMinutes'
};
